import { Controller } from "@hotwired/stimulus"

// UI-09 — Destructive/confirmation modal (DaisyUI <dialog class="modal">).
//
// Each trigger button carries this controller + values; the shared dialog
// (shared/_delete_confirm_dialog) holds a NATIVE <form> whose action + _method
// are populated here on open. Confirmation submits that native form (Rails
// _method), so it works WITHOUT window.confirm() — Brave mobile (and some in-app
// webviews) silently suppress window.confirm(), which made the previous
// turbo_confirm buttons do nothing. It also needs NO cross-scope Stimulus action:
// the old dialog "#confirm" action never routed because the shared dialog lives
// outside any data-controller element (proven: no modal-confirm ancestor), so
// gateway/distibox delete confirmation was silently broken in every browser.
//
//   <button data-controller="modal-confirm"
//           data-action="modal-confirm#open"
//           data-modal-confirm-url-value="/schedules/5/stop"
//           data-modal-confirm-method-value="patch"           (default: delete)
//           data-modal-confirm-title-value="운송 중지"          (default: 삭제 확인)
//           data-modal-confirm-confirm-label-value="중지"       (default: 삭제)
//           data-modal-confirm-variant-value="warning"         (default: error)
//           data-modal-confirm-message-value="이 운송을 중지할까요?">중지</button>
//
// The dialog's confirm submit is a native <form> button — no fetch, no confirm().
// Turbo intercepts the submit and follows the redirect; if Turbo is absent the
// browser submits it natively. Either path works in Brave (only window.confirm
// is suppressed there, not fetch/native form submit).
//
// Auto-registered via the controllers/index.js esbuild glob (do NOT edit index.js).
export default class extends Controller {
  static values = {
    url: String,
    message: String,
    method: { type: String, default: "delete" },
    title: { type: String, default: "삭제 확인" },
    confirmLabel: { type: String, default: "삭제" },
    variant: { type: String, default: "error" },
  }

  open(event) {
    event.preventDefault()
    const dialog = document.getElementById("delete-confirm-dialog")
    if (!dialog) {
      console.warn("modal-confirm: #delete-confirm-dialog not found on page")
      return
    }
    const form = dialog.querySelector("[data-confirm-form]")
    const methodInput = dialog.querySelector("[data-confirm-method]")
    const titleEl = dialog.querySelector("[data-confirm-title]")
    const messageEl = dialog.querySelector("[data-confirm-message]")
    const submitBtn = dialog.querySelector("[data-confirm-submit]")
    if (!form || !methodInput) {
      console.warn("modal-confirm: dialog form/method input missing")
      return
    }

    form.action = this.urlValue
    methodInput.value = this.methodValue
    if (titleEl) titleEl.textContent = this.titleValue
    if (messageEl) messageEl.textContent = this.messageValue
    if (submitBtn) {
      submitBtn.textContent = this.confirmLabelValue
      submitBtn.className = `btn btn-${this.variantValue}`
    }

    if (typeof dialog.showModal === "function") {
      dialog.showModal()
    } else if (window.confirm(this.messageValue)) {
      // Pre-2022 browsers without <dialog>.showModal — submit natively.
      form.submit()
    }
  }
}
